import {connect} from "react-redux";
import ObjectStock from "./ObjectStock";
import {savePage} from "../../globalState/object/actions";
import {compose} from "redux";
import {withRouter} from "react-router-dom";
import {WithObjectComponentHOC} from "../../HOC/WithObjectComponentHOC";
import {WithAppendHeaderAndFooterHOC} from "../../HOC/WithAppendHeaderAndFooterHOC";
import {WithAppendSidebarHOC} from "../../HOC/WithAppendSidebarHOC";
import {WithSavingSnackBar} from "../../HOC/WithSavingSnackBar";


let mapStateToProps = (state) => {
    return {
        headerSubtitle: true,
        stocksFields: state.object.stocksAndDiscounts
    }
};

let mapDispatchToProps = (dispatch) => {
    return {}
};

export default compose(connect(mapStateToProps, {
    mapDispatchToProps,
    savePage
}), withRouter, WithObjectComponentHOC, WithAppendHeaderAndFooterHOC, WithAppendSidebarHOC, WithSavingSnackBar)(ObjectStock);




